<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br>
                    <div>
                        <p class="texto2">Lo sentimos :(</p>
                        <p class="texto1">No es posible gestionar tu seguro debido a tu puntaje
                            financiero actual. Si
                            tienes preguntas, contáctanos.
                        </p>
                    </div>
                    <br>
                    <img src="./assets/img/EducacionFinanciera.png" class="dimensionImg" />
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/EducacionFinanciera.png" class="dimensionImg" />
                    <br><br><br>
                    <div>
                        <p class="texto2">Lo sentimos</p>
                        <p class="texto1">Tu propiedad presenta una restricción y no puede
                            ser asegurada. Acércate a una oficina de registro o
                            ingresa a la <span class="textoEspecial">web del supernotariado.</span>
                        </p>
                    </div>
                </div>
                <br><br>

                <div class="container tamanioBoton">
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-primary w-100 py-2 botonAsesor" type="submit"
                                (click)="cotizacionEnPausa()">
                                Contactar asesor
                            </button>
                        </div>
                        <br><br><br>
                        <div class="col">
                            <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                                onclick="javascript: history.go(-1)">
                                Seguir en línea
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>